import runAfterPageLoad from "./runAfterPageLoad";

export default function initMinicolors(selector) {
  runAfterPageLoad(() => {
    $(selector).minicolors();
  });
}
